namespace advisorop.components.servicer {
    
    export class SelectCuAdvisorCustodianController{
        $router;
        custodians: domains.ICustodian[];
        selCustodian: domains.ICustodian;
        onSelectedCustodian: any;
        static $inject = ["servicerService"];
        constructor(private servicerService: services.ServicerService) {            
            
        }
        
        $onInit(): void {
                          
        }

        $routerOnActivate(next, previous) {          
        }       

        searchCustodians(searchTerm: string): ng.IPromise<{}> {

            return this.servicerService.searchCustodian(searchTerm)
                .then((response) => {
                    return <Array<domains.ICustodian>>response.data;
                });
        }

        onSelectCustodian(item, model, label, event): void {
            this.onSelectedCustodian({ custodian: item });
            this.resetSearch();
        }

        resetSearch(): void {
            this.selCustodian = null;
            //this.advisor = null;
            //this.isAdvisorFormVisible = false;
            //this.noResults = true;
        };        
    }



    class SelectCuAdvisorCustodian implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<",
                onSelectedCustodian: '&'
            };
            this.controller = SelectCuAdvisorCustodianController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/select-cu-advisor-custodian.html';            
        }
    }
    angular.module(Constants.APP).component("selectCuAdvisorCustodian", new SelectCuAdvisorCustodian());
    
}